module.exports = __webpack_public_path__ + "img/shushing-face.73c3cc56.png";